import { render, staticRenderFns } from "./TdTransferRes.vue?vue&type=template&id=7dae9840&"
import script from "./TdTransferRes.vue?vue&type=script&lang=js&"
export * from "./TdTransferRes.vue?vue&type=script&lang=js&"
import style0 from "./TdTransferRes.vue?vue&type=style&index=0&id=7dae9840&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports